import { datajs, datajsAll } from '../shared/utils';

export default class TaxonomyFilter {
	static init() {
		let currentFilterId = this.getInitialFilterId();

		if (!TaxonomyFilter.taxonomyFilter || !TaxonomyFilter.dropdownItems) {
			return;
		}

		const updatecurrentFilterId = (e) => {
			const filter = e.target;
			const filterValue = filter.value;
			currentFilterId = filterValue;

			// Update droprown visibility
			this.updateDropdowns(currentFilterId);
		};

		// Handle click event for each dropdown item
		TaxonomyFilter.dropdownItems.forEach((dropdownItem) => {
			dropdownItem.addEventListener('click', updatecurrentFilterId);
		});

		// Handle initial dropdown visibility
		this.updateDropdowns(currentFilterId, { showBtn: false });
	}

	static getInitialFilterId() {
		const initialSelectedItem = TaxonomyFilter.dropdownItems.find((item) => item.checked);
		const fallbackValue = '0';

		if (initialSelectedItem) {
			return initialSelectedItem.value || fallbackValue;
		} else {
			return fallbackValue;
		}
	}

	static updateDropdowns(filterId, options = { showBtn: true }) {
		const taxonomyFilterLink = datajs('taxonomy-filter-link');
		const dropdowns = datajsAll('taxonomy-filter-dropdown');

		const { showBtn } = options;

		let currentFilterElement = TaxonomyFilter.dropdownItems.find((item) => item.value === filterId);
		let parentFilterId = currentFilterElement.dataset.parentTermId || '0';
		let childTermDropdowns = dropdowns.filter((dropdown) => {
			return dropdown.dataset.parentTermId === currentFilterElement.value;
		});

		const updateDropdownText = function () {
			const currentFilterDropdown = currentFilterElement.closest('.dropdown');
			const currentFilterItemListItem = currentFilterElement.closest('li');
			const currentFilterText = currentFilterItemListItem.querySelector('label').innerHTML;
			const currentDropdownToggle = datajs('taxonomy-filter-dropdown-toggle', currentFilterDropdown);
			const currentDropdownToggleInnerTextElement = currentDropdownToggle.querySelector('.m-dropdown__toggle__innerText');

			// Update the active dropdown text
			currentDropdownToggleInnerTextElement.innerHTML = currentFilterText;

			// Show the dropdown
			currentFilterDropdown.classList.remove('d-none');
		};

		const updateDropdownVisibility = function () {
			// Hide all dropdowns
			dropdowns.forEach((dropdown) => {
				dropdown.classList.add('d-none');

				// Show current filter item
				currentFilterElement.closest('.dropdown').classList.remove('d-none');

				// Show child term dropdown
				if (dropdown.dataset.parentTermId === currentFilterElement.value) {
					dropdown.classList.remove('d-none');
				}
			});

			// Reset child dropdown text
			if (childTermDropdowns.length) {
				childTermDropdowns.forEach((dropdown) => {
					const firstDropdownItem = datajs('taxonomy-filter-dropdown-item');
					const firstDropdownListItem = firstDropdownItem.closest('li');
					const firstDropdownItemText = firstDropdownListItem.querySelector('label').innerHTML;
					const currentDropdownToggle = datajs('taxonomy-filter-dropdown-toggle', dropdown);
					const currentDropdownToggleInnerTextElement = currentDropdownToggle.querySelector('.m-dropdown__toggle__innerText');
					currentDropdownToggleInnerTextElement.innerHTML = firstDropdownItemText;
				});
			}
		};

		// Update filter button link
		if (taxonomyFilterLink) {
			taxonomyFilterLink.href = currentFilterElement.dataset.termUrl;
		}

		// Traverse backwards and update all dropdown toggle texts
		if (currentFilterElement) {
			updateDropdownText();
			updateDropdownVisibility();
			while (parentFilterId !== '0') {
				currentFilterElement = TaxonomyFilter.dropdownItems.find((item) => item.value === parentFilterId);
				parentFilterId = currentFilterElement.dataset.parentTermId || '0';
				updateDropdownText();
			}
		}

		// Update button visibility
		if (showBtn) {
			taxonomyFilterLink.classList.remove('d-none');
		} else {
			taxonomyFilterLink.classList.add('d-none');
		}
	}
}

TaxonomyFilter.taxonomyFilter = datajs('taxonomy-filter');
TaxonomyFilter.dropdownItems = datajsAll('taxonomy-filter-dropdown-item');
